<template>
  <div class="">
    <q-table
      :rows="rows"
      :columns="columnsI18n"
      row-key="id"
      v-model:pagination="pagination"
      :loading="loading"
      :filter="filter"
      @request="onRequest"
      binary-state-sort
      class="sticky-header-table size-md"
    >
      <template v-slot:body-cell-endDate="props">
        <q-td :props="props">
          {{ $moment(props.value).format("DD/MM/YYYY HH:mm:ss") }}
        </q-td>
      </template>

      <template v-slot:body-cell-order="props">
        <q-td :props="props">
          <router-link
            v-if="props.value"
            :to="'/order/' + props.value"
            class="vito-link text-bold"
          >
            <span>{{ props.value }}</span>
          </router-link>
        </q-td>
      </template>

      <template v-slot:body-cell-status="props">
        <q-td :props="props">
          <q-badge :color="statusColor(props.row)" class="text-uppercase">
            {{ $t("label." + statusKey(props.row)) }}
          </q-badge>
        </q-td>
      </template>

      <template v-slot:body-cell-actions="props">
        <q-td :props="props">
          <q-btn
            icon="visibility"
            square
            round
            dense
            flat
            @click="showBarcode(props.row)"
          >
            <q-tooltip class="bg-green-vito text-no-wrap">
              {{ $t("tooltip.showCode") }}
            </q-tooltip>
          </q-btn>
        </q-td>
      </template>
    </q-table>
  </div>

  <q-dialog v-model="barcodeDialog">
    <promotion-barcode :code="selectedCode" />
  </q-dialog>
</template>
<script>
import PromotionApi from "../../apis/Promotion";
import PromotionBarcode from "./PromotionBarcode.vue";
export default {
  props: ["store", "filter"],
  components: { PromotionBarcode },

  data: () => {
    return {
      loading: false,
      pagination: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 50,
        rowsNumber: 0,
      },
      rows: [],
      refreshCounter: 0,
      barcodeDialog: false,
      selectedCode: null,
    };
  },
  methods: {
    showBarcode(row) {
      this.selectedCode = row.code;
      this.barcodeDialog = true;
    },
    statusKey(row) {
      if (row.order) return "used";
      if (new Date(row.endDate) < new Date()) return "expired";
      return "active";
    },
    statusColor(row) {
      const key = this.statusKey(row);
      return key == "active" ? "green-vito" : key == "used" ? "grey" : "red-vito";
    },
    updateProxy() {
      this.refreshCounter += 1;
    },
    async onRequest(props) {
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      const filter = props.filter;
      this.loading = true;
      try {
        const startRow = (page - 1) * rowsPerPage;
        const pageReponse = await PromotionApi.storePaginate({
          storeId: this.store.id,
          startRow,
          fetchCount: rowsPerPage,
          filter,
          sortBy,
          descending,
        });

        this.rows = pageReponse.data.items;
        this.pagination.rowsNumber = pageReponse.data.count;
        this.pagination.page = page;
        this.pagination.rowsPerPage = rowsPerPage;
        this.pagination.sortBy = sortBy;
        this.pagination.descending = descending;
        this.loading = false;
      } catch (error) {
        const message = error.response
          ? error.response.data.message
          : error.message;
        this.errorMessage = message;
        this.$q.notify({
          type: "negative",
          message: message,
        });
      }
    },
    async refresh() {
      this.onRequest({
        pagination: this.pagination,
        filter: this.filter,
      });
      this.showNew = false;
    },
  },

  async mounted() {
    this.onRequest({
      pagination: this.pagination,
      filter: this.filter,
    });
  },

  computed: {
    columnsI18n() {
      const columns = [
        {
          name: "id",
          required: true,
          label: "ID",
          align: "left",
          field: "id",
          sortable: true,
        },
        {
          name: "code",
          label: this.$t("label.code"),
          field: "code",
          align: "center",
          sortable: true,
        },
        {
          name: "store",
          label: this.$t("label.store"),
          field: "store",
          align: "center",
          sortable: false,
        },
        {
          name: "type",
          label: this.$t("label.type"),
          field: "type",
          format: (val) =>
            this.$t(
              val == "percent" ? "label.promotionPercent" : "label.promotionAmount"
            ),
          align: "center",
          sortable: true,
        },
        {
          name: "amount",
          label: this.$t("label.amount"),
          field: "amount",
          format: (val, row) =>
            val + " " + (row.type == "percent" ? "%" : this.currency),
          align: "center",
          sortable: true,
        },
        {
          name: "endDate",
          label: this.$t("label.endDate"),
          field: "endDate",
          align: "center",
          sortable: true,
        },
        {
          name: "order",
          label: this.$t("label.order"),
          field: "order",
          align: "center",
          sortable: false,
        },
        {
          name: "status",
          label: this.$t("label.status"),
          field: "id",
          align: "center",
          sortable: false,
        },
        { name: "actions", style: "width:70px" },
      ];
      return columns;
    },
    currency() {
      return this.$store.getters.currency;
    },
  },
};
</script>
